import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import UserContext from '../tools/contextLib';
import 'bootstrap/dist/css/bootstrap.min.css';
import { browserName, browserVersion } from 'react-device-detect';
import axios from 'axios';
import { Table, Form, Input, FormGroup, FormText, Button, Modal,ModalHeader,ModalBody,ModalFooter,Label } from 'reactstrap';
import { connect } from 'react-redux';
import LoadingSpin from "react-loading-spin";
import classnames from 'classnames';

class BreakResidence extends Component {
    static displayName = BreakResidence.name;

    constructor(props)  {
        super(props);
        this.state = {
            returnable: this.props.reduxData.userInfo,
            browser: `${browserName}${browserVersion}`,
            permissionFlag: true,
            breakList: [],
            activeBreak: "DEFAULT",
            studentsForBreak: [],
            newStudent: "",
            studentName: "",
            modalOpen: false,
            newBreak: "",
            breakStart: "",
            breakEnd: "",
            editModal: false,
            editStart: "",
            editEnd: "",
            deleteModal: false,
            uploadFile: [],
            startTime: "",
            endTime: "",
            editStartTime: "",
            editEndTime: ""
        }
        this.testPermission();
    }

    async testPermission() {
        let bearerVAR = "Bearer " + this.props.reduxData.apiKey
        this.props.updateFetchTime();
        let toSend = {
            userLevel: this.props.reduxData.userInfo.level.pk,
            pagepk: "/BreakResidence"
        }
        const response = await fetch('ValidDepartments', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
            body: JSON.stringify(toSend)
        })
        const data = await response.json();
        this.setState({
            permissionFlag: data
        }, () => {this.getData() })
    }

    async getData() {
        let bearerVAR = "Bearer " + this.props.reduxData.apiKey
        this.props.updateFetchTime();
        const response = await fetch('BreakResGetBreaks', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR }
        })
        const data = await response.json();
        this.setState({
            breakList: data,
            
        })
    }

    componentDidMount() {

    }

    async setActive(e) {
        let thisStart = this.state.breakList.filter(remove => remove.pk == e)[0].start;
        let thisEnd = this.state.breakList.filter(remove => remove.pk == e)[0].end;
        this.setState({
            activeBreak: e,
            editStart: thisStart.slice(0, thisStart.indexOf(" ")),
            editEnd: thisEnd.slice(0, thisStart.indexOf(" ")),
            editStartTime: thisStart.slice(thisStart.indexOf(" ") + 1),
            editEndTime: thisEnd.slice(thisEnd.indexOf(" ") + 1)
        })
        let bearerVAR = "Bearer " + this.props.reduxData.apiKey
        this.props.updateFetchTime();
        let toSend = {
            pk: e
        }
        const response = await fetch('BreakResGetStudents', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
            body: JSON.stringify(toSend)
        })
        const data = await response.json();
        this.setState({
            studentsForBreak: data,
            newStudent: ""
        })
    }

    async studentType(e) {
        this.setState({
            newStudent: e
        })
        if (e.length == 10) {
            let bearerVAR = "Bearer " + this.props.reduxData.apiKey
            this.props.updateFetchTime();
            let toSend = {
                stuPCID: e,
                userLevel: this.props.reduxData.userInfo.level.pk
            }
            const response = await fetch('StuLookupBreakRes', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
                body: JSON.stringify(toSend)
            })
            const data = await response.json();
            this.setState({
                studentName: data.stuName
            })
        }
        else {
            this.setState({
                studentName: ""
            })
        }
    }

    async addNewStudent(e) {
        e.preventDefault();
        let bearerVAR = "Bearer " + this.props.reduxData.apiKey
        this.props.updateFetchTime();
        let toSend = {
            pk: this.state.activeBreak,
            stu: this.state.newStudent
        }
        const response = await fetch('BreakResAddStudent', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
            body: JSON.stringify(toSend)
        })
        const data = await response.json();
        this.setState({
            studentsForBreak: data,
            newStudent: ""
        })
    }

    async deleteStudent(e) {
        let bearerVAR = "Bearer " + this.props.reduxData.apiKey
        this.props.updateFetchTime();
        let toSend = {
            pk: e
        }
        const response = await fetch('BreakResDeleteStu', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
            body: JSON.stringify(toSend)
        })
        const data = await response.json();
        this.setState({
            studentsForBreak: data
        })
    }

    toggleModal() {
        this.setState({
            modalOpen: !this.state.modalOpen
        })
    }

    async addBreak() {
        this.toggleModal();
        let toSend = {
            name: this.state.newBreak,
            start: this.state.breakStart,
            end: this.state.breakEnd,
            starttime: this.state.startTime,
            endtime: this.state.endTime
        }
        let bearerVAR = "Bearer " + this.props.reduxData.apiKey
        this.props.updateFetchTime();
        const response = await fetch('BreakResAddBreak', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
            body: JSON.stringify(toSend)
        })
        const data = await response.json();
        this.setState({
            breakList: data,
            activeBreak: "DEFAULT",
            studentName: "",
            newStudent: ""
        })
    }

    toggleEdit() {
        this.setState({
            editModal: !this.state.editModal
        })
    }

    async updateBreak() {
        this.toggleEdit();
        let toSend = {
            pk: this.state.activeBreak,
            newstart: this.state.editStart,
            newend: this.state.editEnd,
            newstarttime: this.state.editStartTime,
            newendtime: this.state.editEndTime
        }
        let bearerVAR = "Bearer " + this.props.reduxData.apiKey
        this.props.updateFetchTime();
        const response = await fetch('BreakResEditBreak', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
            body: JSON.stringify(toSend)
        })
        const data = await response.json();
        this.setState({
            activeBreak: "DEFAULT",
            editStart: "",
            editEnd: "",
            editStartTime: "",
            editEndTime: "",
            newStudent: ""
        }, () => {this.getData() })
    }

    toggleDelete() {
        this.setState({
            deleteModal: !this.state.deleteModal
        })
    }

    async deleteBreak() {
        this.toggleDelete()
        let toSend = {
            pk: this.state.activeBreak
        }
        let bearerVAR = "Bearer " + this.props.reduxData.apiKey
        this.props.updateFetchTime();
        const response = await fetch('BreakResDeleteBreak', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
            body: JSON.stringify(toSend)
        })
        const data = await response.json();
        this.setState({
            activeBreak: "DEFAULT",
            editStart: "",
            editEnd: "",
            newStudent: ""
        }, () => { this.getData() })
    }

    handleFileChange(e) {//This handles selecting a file to be added
        if (e.target.files) {
            this.setState({
                uploadFile: e.target.files[0]
            })
            //console.log("file ready: ", e.target.files[0])
        }
    }

    async uploadButton() {
        let bearerVAR = "Bearer " + this.props.reduxData.apiKey
        this.props.updateFetchTime();
        const formData = new FormData();
        formData.append("file", this.state.uploadFile);
        formData.append("breakpk", this.state.activeBreak);
        formData.append("filename", this.state.uploadFile.name);
        if (this.state.uploadFile.name.slice(-4) == ".csv") {
            const res = await axios.post("BreakResStudentListCSV", formData, {
                headers: { 'Authorization': bearerVAR }
            });
            this.setState({
                studentsForBreak: res.data
            })
        }
        

        //application/vnd.ms-excel
    }

    studentTable() {
        return (<div>
            <Modal isOpen={this.state.editModal} toggle={this.toggleEdit.bind(this)}>
                <ModalBody>
                    <FormGroup>
                        <Label>Break Starts On</Label>
                        <Input type="date" value={this.state.editStart} onChange={(e) => this.setState({ editStart: e.target.value })} />
                    </FormGroup>
                    <FormGroup>
                        <Label>Break Starts At</Label>
                        <Input type="time" value={this.state.editStartTime} onChange={(e) => this.setState({editStartTime: e.target.value}) } />
                    </FormGroup>
                    <FormGroup>
                        <Label>Break Ends On</Label>
                        <Input type="date" value={this.state.editEnd} onChange={(e) => this.setState({ editEnd: e.target.value })} />
                    </FormGroup>
                    <FormGroup>
                        <Label>Break Ends At</Label>
                        <Input type="time" value={this.state.editEndTime} onChange={(e) => this.setState({ editEndTime: e.target.value })} />
                    </FormGroup>
                </ModalBody>
                <ModalFooter><Button onClick={() => this.updateBreak() }>OK</Button></ModalFooter>
            </Modal>
            <Modal isOpen={this.state.deleteModal} toggle={this.toggleDelete.bind(this)}>
                <ModalHeader>Warning!</ModalHeader>
                <ModalBody>
                    This action will delete this break. The special rules applied to this time period will be revoked. If this is done in error, the break and all students in it will have to be rebuilt manually.<br />
                    Are you sure you want to do this?
                </ModalBody>
                <ModalFooter>
                    <Button onClick={() => this.toggleDelete()}>Nevermind</Button>
                    <Button onClick={() => this.deleteBreak()}>I'm sure, delete</Button>
                </ModalFooter>
            </Modal>
            <div className="inlineCustom">
                <Form className="d-flex">
                    <FormGroup>
                        <Input type="text" value={this.state.newStudent} onChange={(e) => this.studentType(e.target.value)} placeholder="PCID" />
                        <FormText>{this.state.studentName}</FormText>
                    </FormGroup>
                    &ensp;
                    <FormGroup>
                        <Button onClick={(e) => this.addNewStudent(e)}>Add</Button>
                    </FormGroup>
                </Form>
            </div>
            &ensp;&ensp;&ensp;&ensp;&ensp;&ensp;
            <div className="inlineCustom">
                <Form className="d-flex"><FormGroup><Input type="file" name="fileUpload" id="fileUpload" accept=".csv" onChange={(e) => this.handleFileChange(e)} /></FormGroup><FormGroup><Button onClick={() => this.uploadButton()}>Upload</Button></FormGroup></Form>
            </div>
            <div className="rightAlignCustom">
                <Button onClick={() => this.toggleEdit()}>Edit: {this.state.breakList.filter(remove => remove.pk == this.state.activeBreak)[0].name}</Button>&nbsp;
                <Button color="danger" onClick={() => { this.toggleDelete() }}>Delete: {this.state.breakList.filter(remove => remove.pk == this.state.activeBreak)[0].name}</Button>
            </div>
            <br />
            <div className="centerDiv"><b>
                {this.state.breakList.filter(remove => remove.pk == this.state.activeBreak)[0].name}: {this.state.breakList.filter(remove => remove.pk == this.state.activeBreak)[0].startdisplay} to {this.state.breakList.filter(remove => remove.pk == this.state.activeBreak)[0].enddisplay}
            </b></div>
            <Table striped>
                <thead>
                    <tr>
                        <th className="w-45" style={{ textAlign: 'right' }}>PCID</th>
                        <th className="w-45">Name</th>
                        <th className="w-10"></th>
                    </tr>
                </thead>
                <tbody>
                    {this.state.studentsForBreak.map(item => (
                        <tr>
                            <td className="w-45" style={{ textAlign: 'right' }}>{item.pcid}</td>
                            <td className="w-45">{item.name}</td>
                            <td className="w-10"><Button color="danger" outline onClick={(e) => { e.preventDefault(); this.deleteStudent(item.pk) }}>Delete</Button></td>
                        </tr>
                    ))}
                </tbody>
            </Table>
        </div>)
    }

    render() {
        if (this.state.permissionFlag == false) {
            this.props.passNewPage(-1);
        }
        return (<div>
            <Modal isOpen={this.state.modalOpen} toggle={this.toggleModal.bind(this)}>
                <ModalHeader toggle={this.toggleModal.bind(this)}>Create a new break</ModalHeader>
                <ModalBody>
                    <Form>
                        <FormGroup>
                            <Label>Break Name</Label>
                            <Input type="text" name="breakname" id="breakname" value={this.state.newBreak} onChange={(e) => this.setState({ newBreak: e.target.value })} />
                        </FormGroup>
                        <FormGroup>
                            <Label>Break Start Date</Label>
                            <Input type="date" name="breakstart" id="breakstart" value={this.state.breakStart} onChange={(e) => this.setState({ breakStart: e.target.value })} />
                        </FormGroup>
                        <FormGroup>
                            <Label>Break Start Time</Label>
                            <Input type="time" name="starttime" id="starttime" value={this.state.startTime} onChange={(e) => this.setState({ startTime: e.target.value}) } />
                        </FormGroup>
                        <FormGroup>
                            <Label>Break End Date</Label>
                            <Input type="date" name="breakend" id="breakend" value={this.state.breakEnd} onChange={(e) => this.setState({ breakEnd: e.target.value })} />
                        </FormGroup>
                        <FormGroup>
                            <Label>Break End Time</Label>
                            <Input type="time" name="endtime" id="endtime" value={this.state.endTime} onChange={(e) => this.setState({endTime: e.target.value}) } />
                        </FormGroup>
                    </Form>
                </ModalBody>
                <ModalFooter><Button onClick={() => this.addBreak()}>Add</Button></ModalFooter>
            </Modal>
            <div className="halfOfParent inlineCustom"><Input type="select" value={this.state.activeBreak} onChange={(e) => this.setActive(e.target.value)}>
                <option value="DEFAULT" disabled>Select...</option>
                {this.state.breakList.map(item => (
                    <option value={item.pk}>{item.name}</option>
                )) }
            </Input></div>
            <br />
            {/*{this.state.activeBreak != "DEFAULT" &&*/}
            {/*    <div className="inlineCustom rightAlignCustom">{this.state.breakList.filter(remove => remove.pk == this.state.activeBreak)[0].start} to {this.state.breakList.filter(remove => remove.pk == this.state.activeBreak)[0].end }</div>}<p />*/}
            <Button onClick={() => this.toggleModal()}>Create New Break</Button >
            <p />
            <p />
            {this.state.activeBreak != "DEFAULT" && this.studentTable()}
        </div>)
    }
}

const mapStateTo = state => ({
    reduxData: state
})

const mapDispatchTo = (dispatch) => {
    return {
        updateFetchTime: () => dispatch({ type: 'foundation/setFetchTime' })
    }
}

export default connect(mapStateTo, mapDispatchTo)(BreakResidence);